import { Controller, useFormContext } from "react-hook-form";
import { InputPhoneNumber, InputPhoneNumberProps } from "../index";

export type FormInputPhoneNumberProps = Omit<
  InputPhoneNumberProps,
  "value" | "onChange"
> & {
  name?: string;
};

export const FormInputPhoneNumber = ({
  name = "phoneNumber",
  ...props
}: FormInputPhoneNumberProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState: { error } }) => (
        <InputPhoneNumber
          {...props}
          value={field.value || ""}
          onChange={field.onChange}
          error={error?.message}
        />
      )}
    />
  );
};
